<ng-container *ngFor="let group of data; let last = last">
  <div class="items p-5">
    <a *ngFor="let item of group" class="item ui-label-m-bold text-low-contrast" href="{{item[3]}}"
       target="{{item[4]}}">

      <div class="item__image-container">
      <span [ngStyle]="{'background-position':item[2]}"
            class="item__image-container__image"> </span>
      </div>
      <span class="item__name-container">{{ item[1] }} </span>
    </a>
  </div>
  <span class="spacer"></span>
</ng-container>
<ng-container>
  <a rds-link standalone href="https://workspace.google.com/marketplace?pann=ogb&amp;authuser=0" target="_blank"
     aria-label="More from Google Workspace Marketplace (opens a new tab)">
    <button rds-text-button style="margin: 24px 24px 12px 24px;">
      More from Google Workspace Marketplace
    </button>
  </a>
</ng-container>
